import { module as modujs } from "modujs";

export default class extends modujs {
	constructor(m) {
		super(m);

		this.events = {
			click: {
				next: "changeIndex",
				prev: "changeIndex",
			},
		};
	}

	init() {
		this.$quotes = this.$("quote");
		this.$authors = this.$("author");
		this.$logos = this.$("logo");
		this.$lists = this.$("list");

		// Set initial state
		this.currentIndex = 0;
		this.totalItems = this.$quotes.length;

		// Show the first item, hide others
		this.fadeInOut();
	}

	changeIndex(e) {
		// Determine if next or prev was clicked
		const isNext = e.currentTarget.classList.contains("-right");

		// Update the current index
		if (isNext) {
			this.currentIndex = (this.currentIndex + 1) % this.totalItems;
		} else {
			this.currentIndex = (this.currentIndex - 1 + this.totalItems) % this.totalItems;
		}

		// Update the display
		this.fadeInOut();
	}

	fadeInOut() {
		// Remove active class from all items
		this.$quotes.forEach((quote) => quote.classList.remove("-active"));
		this.$authors.forEach((author) => author.classList.remove("-active"));
		this.$logos.forEach((logo) => logo.classList.remove("-active"));
		this.$lists.forEach((list) => list.classList.remove("-active"));

		// Add active class to current items
		this.$quotes[this.currentIndex].classList.add("-active");
		this.$authors[this.currentIndex].classList.add("-active");
		this.$logos[this.currentIndex].classList.add("-active");
		this.$lists[this.currentIndex].classList.add("-active");
	}

	destroy() {}
}
